import { Network } from "../../.."
import store from "../../../../store"

export class EmployerPlanPricingAttributes {
	constructor(attr) {
		Object.assign(this, attr)
	}

	// No type annotations in JS
	// Properties will just be dynamically assigned
}

class EmployerPlanPricing extends EmployerPlanPricingAttributes {
	static async getForEmployerById({ params }) {
		try {
			const {
				data: { data: employerPlanPricingData }
			} = await Network.AxiosWrapperV2.get({
				url: `employer/${params.employerId}/pricing`
			})

			const employerPlanPricing = new Map()
			employerPlanPricingData.forEach((plan) => {
				employerPlanPricing.set(plan.plan.id, new EmployerPlanPricing(plan))
			})
			return employerPlanPricing
		} catch (err) {
			console.error(err)
		}
	}

	async updatePlanPricing({ data }) {
		try {
			const { data: employerData } = await Network.AxiosWrapperV2.send({
				...this.links.update,
				data
			})

			await store.setNotification("notification", true, {
				msg: `Successfully updated ${this.plan.type} pricing.`,
				severity: "success",
				isPersist: true
			})
			return new EmployerPlanPricing(employerData)
		} catch (err) {
			console.error(err)
		}
	}
}

export default EmployerPlanPricing
